import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';
import { useLanguage } from '../context/LanguageContext';

const pages = [
  { label: 'Dashboard', icon: 'fa-chart-pie', path: '/dashboard' },
  { label: 'Gift Cards', icon: 'fa-gift', path: '/dashboard/gift-cards' },
  { label: 'New Gift Card', icon: 'fa-plus', path: '/dashboard/gift-cards/new' },
  { label: 'Suppliers', icon: 'fa-store', path: '/dashboard/suppliers' },
  { label: 'Transactions', icon: 'fa-exchange-alt', path: '/dashboard/transactions' },
  { label: 'Reports', icon: 'fa-file-alt', path: '/dashboard/reports' },
  { label: 'Users', icon: 'fa-users', path: '/dashboard/users' },
  { label: 'Settings', icon: 'fa-cog', path: '/dashboard/settings' },
];

export default function CommandPalette({ onClose, navigate }) {
  const { formatCurrency } = useLanguage();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(pages);
  const [cards, setCards] = useState([]);
  const [active, setActive] = useState(0);
  const inputRef = useRef();

  useEffect(() => {
    inputRef.current?.focus();
    api.get('/gift-cards', { params: { limit: 50 } })
      .then(res => setCards(res.data.data || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const q = query.toLowerCase();
    if (!q) {
      setResults(pages);
      setActive(0);
      return;
    }

    const pageResults = pages.filter(p => p.label.toLowerCase().includes(q))
      .map(p => ({ ...p, type: 'page' }));

    const cardResults = cards.filter(c =>
      c.code.toLowerCase().includes(q) ||
      c.supplier?.name?.toLowerCase().includes(q) ||
      c.cardNumber?.includes(q)
    ).slice(0, 5).map(c => ({
      label: `${c.code} - ${c.supplier?.name}`,
      icon: 'fa-gift',
      path: `/gift-cards/${c.id}`,
      type: 'card',
      subtitle: `${formatCurrency(c.currentValue)}`
    }));

    setResults([...pageResults, ...cardResults]);
    setActive(0);
  }, [query, cards]);

  const handleSelect = (item) => {
    navigate(item.path);
    onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(a => Math.min(a + 1, results.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(a => Math.max(a - 1, 0));
    } else if (e.key === 'Enter' && results[active]) {
      handleSelect(results[active]);
    }
  };

  return (
    <div className="command-palette-overlay" onClick={onClose}>
      <div className="command-palette" onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '0 1.25rem' }}>
          <i className="fas fa-search" style={{ color: '#94A3B8', marginRight: '0.5rem' }}></i>
          <input
            ref={inputRef}
            placeholder="Search pages, gift cards... (Ctrl+K)"
            value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <kbd style={{ background: '#F1F5F9', padding: '2px 6px', borderRadius: 4, fontSize: '0.7rem', color: '#64748B' }}>ESC</kbd>
        </div>
        <div className="command-palette-results">
          {results.length === 0 && (
            <div style={{ padding: '1.5rem', textAlign: 'center', color: '#94A3B8', fontSize: '0.875rem' }}>
              No results found
            </div>
          )}
          {results.map((item, i) => (
            <div
              key={i}
              className={`command-palette-item ${i === active ? 'active' : ''}`}
              onClick={() => handleSelect(item)}
              onMouseEnter={() => setActive(i)}
            >
              <i className={`fas ${item.icon}`}></i>
              <div style={{ flex: 1 }}>
                <div>{item.label}</div>
                {item.subtitle && <small style={{ color: '#94A3B8' }}>{item.subtitle}</small>}
              </div>
              {item.type === 'card' && <span className="badge bg-primary" style={{ fontSize: '0.65rem' }}>Card</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
